import { combineReducers } from "redux";
import { routerReducer } from "react-router-redux";
import auth from "./auth/reducer";
import project from "./projects/reducer";
import file from "./files/reducer";
import issue from "./issues/reducer";
import checklists from "./checklists/reducer";
import templates from "./templates/reducer";
import locations from "./locations/reducer";

export default combineReducers({
  router: routerReducer,
  auth,
  project,
  file,
  issue,
  checklists,
  templates,
  locations
});
